import { MainStore } from "../useStoreMain";

export const selectInit = (state: MainStore) => state.init;
export const getIsAuthorized = (state: MainStore) => state.isAuthorized;
export const getIsAuthInitialized = (state: MainStore) =>
  state.isAuthInitialized;
export const selectSetIsAuthorized = (state: MainStore) =>
  state.setIsAuthorized;
